import React from "react";
import { useLang } from "../context/LangContext";

const Marquee = () => {
  const { t } = useLang();
  const items = [...t.marquee, ...t.marquee, ...t.marquee];

  return (
    <div className="bg-brand-navy py-5 overflow-hidden border-y border-brand-navy-deep" data-testid="marquee-band">
      <div className="flex marquee-track whitespace-nowrap gap-12">
        {items.map((item, i) => (
          <div key={`${item}-${i}`} className="flex items-center gap-12">
            <span className="font-display text-lg sm:text-xl font-semibold text-white tracking-tight">
              {item}
            </span>
            <span className="w-2 h-2 rounded-full bg-brand-orange flex-shrink-0" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
